import React, { useState } from 'react';
import Link from 'next/link'
import type { NextPage } from 'next';
import styles from './index.module.scss';
import cName from "classnames";
import Wrapper from '@/components/wrapper';
import CountUp from 'react-countup';
import TicketModal from '@/components/ticket-modal';
import { getServerSideProps, getHead } from '@/utils/useHead';
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";

interface IProps {

}
export { getServerSideProps }

const Why: NextPage<IProps> = ({ menuDetail }: any) => {
  const router = useRouter();
  const t = useTranslations("visitor.why");

  const [isShowTicketModal, setIsShowTicketModal] = useState(false)

  return (
    <div>
      <Wrapper>
        <div className={cName([styles.container])}>
          {getHead(menuDetail)}
          <div className={cName([styles.reason, 'm-1600'])}>
            <h2>{t('section1.title')}</h2>
            <div className={styles.intro}>
              <div className={styles.left}>
                <div>
                  <h3>{t('section1.subtitle_cn')}</h3>
                  <h3 style={{ color: '#fcb814' }}>{t('section1.subtitle_en')}</h3>
                </div>
                <ul>
                  <li>
                    <img src="/image/beer-pong.png" alt="" />
                    <div>
                      <p dangerouslySetInnerHTML={{ __html: t('section1.item1tit') }}></p>
                    </div>
                  </li>
                  <li>
                    <img src="/image/presentation1.png" alt="" />
                    <div>
                      <p dangerouslySetInnerHTML={{ __html: t('section1.item2tit') }}></p>
                    </div>
                  </li>
                  <li>
                    <img src="/image/search-location.png" alt="" />
                    <div>
                      <p dangerouslySetInnerHTML={{ __html: t('section1.item3tit') }}></p>
                    </div>
                  </li>
                  <li>
                    <img src="/image/beer-bottle1.png" alt="" />
                    <div>
                      <p dangerouslySetInnerHTML={{ __html: t('section1.item4tit') }}></p>
                    </div>
                  </li>
                </ul>
              </div>
              <div className={styles.right}>
                <div className={styles.videoBox}>
                  <video src="https://img.cbcechina.com/2026-05-28/87961ff87ecfd343b5ef332336e33ff5.mp4"
                    loop
                    muted
                    playsInline
                    controls
                    poster="https://img.cbcechina.com/2024-12-10/ca7c7b2fc08900805c65caebef9d183c.png"></video>
                </div>
              </div>
            </div>
            <div className={cName([styles.btns])}>
              <Link href="/exhibition/apply">
                <a>
                  <div className={cName([styles.register, 'btnStyle'])}>
                    <span>{t('section1.btn1')}</span>
                    {/* @ts-ignore */}
                    <svg t="1723196878237" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                      <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#ffffff">
                      </path>
                    </svg>
                  </div>
                </a>
              </Link>
              <Link href="https://cbce2025.gration.cn/?member/register&code=sites">
                <a target="_blank">
                  <div className={cName([styles.order, 'btnStyle'])}>
                    <span>{t('section1.btn2')}</span>
                    {/* @ts-ignore */}
                    <svg t="1723196878237" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                      <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#FCB814">
                      </path>
                    </svg>
                  </div>
                </a>
              </Link>
            </div>
          </div>
          <img className={styles.banner} src="https://img.cbcechina.com/2025-07-18/1e22118f3e0859722d25848a55b8bd83.png" alt="" />
          <div className={cName([styles.box, 'm-1600'])}>
            <div className={styles.top}>
              <div className={styles.left}>
                <h2>{t('section2.top.title')}</h2>
                <p>{t('section2.top.text')}</p>
                <Link href="/online/exhibitor">
                  <a>
                    <div className={cName([styles.more, 'btnStyle'])}>
                      <span>{t('section2.top.btn')}</span>
                      {/* @ts-ignore */}
                      <svg t="1723196878237" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                        <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#FCB814">
                        </path>
                      </svg>
                    </div>
                  </a>
                </Link>
              </div>
              <div className={styles.right}>
                <img src="/image/visitor-why-photo1.png" alt="" />
              </div>
            </div>
            <div className={styles.bottom}>
              <div className={styles.left}>
                <img src="/image/visitor-why-photo2.png" alt="" />
              </div>
              <div className={styles.right}>
                <h2>{t('section2.bottom.title')}</h2>
                <p>{t('section2.bottom.text')}</p>
                <ul>
                  <li>
                    <img src="/image/scalability.png" alt="" />
                    <div>
                      <p><CountUp
                        end={parseInt(t('section2.bottom.item1num'))}
                        duration={1}
                        enableScrollSpy
                      /><span style={{ fontSize: '24px' }}>{t('section2.bottom.item1unit')}</span></p>
                      <span>{t('section2.bottom.item1tit')}</span>
                    </div>
                  </li>
                  <li>
                    <img src="/image/beer-bottle.png" alt="" />
                    <div>
                      <p><CountUp
                        end={parseInt(t('section2.bottom.item2num'))}
                        duration={1}
                        enableScrollSpy
                      /><span>{t('section2.bottom.item2unit')}</span></p>
                      <span>{t('section2.bottom.item2tit')}</span>
                    </div>
                  </li>
                  <li>
                    <img src="/image/users.png" alt="" />
                    <div>
                      <p><CountUp
                        end={parseInt(t('section2.bottom.item3num'))}
                        duration={1}
                        enableScrollSpy
                      /><span style={{ fontSize: '24px' }}>{t('section2.bottom.item3unit')}</span></p>
                      <span>{t('section2.bottom.item3tit')}</span>
                    </div>
                  </li>
                  <li>
                    <img src="/image/calendar.png" alt="" />
                    <div>
                      <p><CountUp
                        end={parseInt(t('section2.bottom.item4num'))}
                        duration={1}
                        enableScrollSpy
                      /><span style={{ fontSize: '24px' }}>{t('section2.bottom.item4unit')}</span></p>
                      <span>{t('section2.bottom.item4tit')}</span>
                    </div>
                  </li>
                </ul>
                <Link href="/schedule">
                  <a>
                    <div className={cName([styles.more, 'btnStyle'])}>
                      <span>{t('section2.bottom.btn')}</span>
                      {/* @ts-ignore */}
                      <svg t="1723196878237" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                        <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#FCB814">
                        </path>
                      </svg>
                    </div>
                  </a>
                </Link>
              </div>
            </div>
          </div>
          <div className={cName([styles.meeting, 'm-1600'])}>
            <div>
              <h2>{t('section3.title')}</h2>
              <div>
                <p dangerouslySetInnerHTML={{ __html: t('section3.text') }}></p>
                <div className={styles.btns}>
                  <Link href="/summit/2025">
                    <a>
                      <div className={cName([styles.more, 'btnStyle'])}>
                        <span>{t('section3.btn1')}</span>
                        {/* @ts-ignore */}
                        <svg t="1723196878237" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                          <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#231F20">
                          </path>
                        </svg>
                      </div>
                    </a>
                  </Link>
                  <div className={cName([styles.buy, 'btnStyle'])} onClick={() => setIsShowTicketModal(true)}>
                    <span>{t('section3.btn2')}</span>
                    {/* @ts-ignore */}
                    <svg t="1723196878237" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                      <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673">
                      </path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={cName([styles.forum, 'm-1600'])}>
            <div>
              <h2 className=''>{t('section4.title')}</h2>
              <div>
                <p dangerouslySetInnerHTML={{ __html: t('section4.text') }}></p>
                <div className={styles.btns}>
                  <Link href="/summit/2025">
                    <a>
                      <div className={cName([styles.more, 'btnStyle'])}>
                        <span>{t('section4.btn1')}</span>
                        {/* @ts-ignore */}
                        <svg t="1723196878237" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                          <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#231F20">
                          </path>
                        </svg>
                      </div>
                    </a>
                  </Link>
                  <div className={cName([styles.buy, 'btnStyle'])} onClick={() => setIsShowTicketModal(true)}>
                    <span>{t('section4.btn2')}</span>
                    {/* @ts-ignore */}
                    <svg t="1723196878237" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2672" width="14" height="14">
                      <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673">
                      </path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <TicketModal visible={isShowTicketModal} onCancel={() => setIsShowTicketModal(false)}></TicketModal>
        </div>
      </Wrapper>
    </div>
  );
};

export default Why;
